<template>
    <div class="how-to-play__content">
        <h1 class="how-to-play__content-title">{{ getTranslatedText("Fafi, or Mo-China, is a form of betting game using your dreams to select your numbers. Traditionally this was played on the streets by workers with their wagers.") }}</h1>
        <span class="how-to-play__content-text hl">{{ getTranslatedText("Here are the steps to play Fafi:") }}</span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Understand the Symbols:") }}</b>
            {{ getTranslatedText(`In the Fafi game, there are [length] numbers, each associated with a different symbol or picture. For example, number 1 might be represented by a 'man', number 2 by a 'woman', and so on. It's important to familiarize yourself with these symbols as they are commonly used by players and bookmakers.`,
                {
                    length,
                }
            ) }}
        </span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Choose Your Numbers:") }}</b>
            {{ getTranslatedText("Pick your numbers from 1 to [length]. you can choose a maximum of 10 numbers per draw.",
                {
                    length,
                }
            ) }}
        </span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Place Your Bet:") }}</b>
            {{ getTranslatedText("Go to a Fafi operator or bookmaker and place your bet. The amount you can bet may vary from one operator to another.") }}
        </span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Draw:") }}</b>
            {{ getTranslatedText("The draw usually happens once or twice a day but is also an instant game, depending on the operator. Some operators use a random draw, while others may use the last two digits of the closing price of a certain stock exchange, or some other publicly available numbers.") }}
        </span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Check the Results:") }}</b>
            {{ getTranslatedText("After the draw, check if your numbers match the drawn numbers.") }}
        </span>
        <span class="how-to-play__content-text">
            <b>{{ getTranslatedText("Collect Your Winnings:") }}</b>
            {{
                getTranslatedText(
                    'If you win, you can collect your winnings from the same operator where you placed your bet. The payout is 1 in [length] times your wager.  Wager * [odd] = Payout.',
                    {
                        length,
                        odd: length - 1
                    }
                )
            }}
        </span>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins"

export default {
    mixins: [languageMixins],
    props: {
        length: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style lang="scss">
@import "~ThemePath/scss/home/index.scss";
</style>
